/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack() {
    var _a, _b;
    (_b = (_a = window === null || window === void 0 ? void 0 : window.history) === null || _a === void 0 ? void 0 : _a.back) === null || _b === void 0 ? void 0 : _b.call(_a);
}

export { navigateBack as default };
